/**
 * @enum {number}
 */
var _ol_ViewHint_ = {
  ANIMATING: 0,
  INTERACTING: 1
};

export default _ol_ViewHint_;



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ol/viewhint.js
// module id = ../../../../ol/viewhint.js
// module chunks = vendor